/**
 * <cart-drawer> — open/close only. No inline script; load from head with defer.
 * Listeners live on the component and on the cart trigger; no document-level click delegation.
 */
(function () {
  var OPEN_CLASS = 'cart-open';
  var focusBeforeOpen = null;

  function getFocusables(container) {
    if (!container) return [];
    var sel = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(sel), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function setTriggerExpanded(expanded) {
    var val = expanded ? 'true' : 'false';
    document.querySelectorAll('.cart-trigger').forEach(function (el) {
      el.setAttribute('aria-expanded', val);
    });
  }

  function closeDrawer() {
    document.documentElement.classList.remove(OPEN_CLASS);
    setTriggerExpanded(false);
    if (focusBeforeOpen && typeof focusBeforeOpen.focus === 'function') {
      focusBeforeOpen.focus();
      focusBeforeOpen = null;
    }
  }

  function openDrawer() {
    document.documentElement.classList.remove('show-mobile-menu');
    document.documentElement.classList.add(OPEN_CLASS);
    setTriggerExpanded(true);
    focusBeforeOpen = document.activeElement;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var focusables = getFocusables(drawer);
      if (focusables.length) focusables[0].focus();
    }
  }

  function toggleDrawer() {
    if (document.documentElement.classList.contains(OPEN_CLASS)) closeDrawer();
    else openDrawer();
  }

  function bindCartTrigger() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    document.querySelectorAll('.cart-trigger').forEach(function (el) {
      if (!el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', 'false');
      el.setAttribute('aria-haspopup', 'dialog');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.toggle();
      });
    });
  }

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this._boundClick = this._onClick.bind(this);
      this._boundKeydown = this._onKeydown.bind(this);
    }

    _onClick(e) {
      if (!e.target.closest('[data-cart-drawer-close], [data-cart-close]')) return;
      e.preventDefault();
      this.close();
    }

    _onKeydown(e) {
      if (e.code === 'Escape' && document.documentElement.classList.contains(OPEN_CLASS)) {
        this.close();
        return;
      }
      if (e.code !== 'Tab' || !this.contains(document.activeElement)) return;
      var focusables = getFocusables(this);
      if (focusables.length < 2) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    connectedCallback() {
      this.addEventListener('click', this._boundClick);
      document.addEventListener('keydown', this._boundKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._boundClick);
      document.removeEventListener('keydown', this._boundKeydown);
    }

    open() { openDrawer(); }
    close() { closeDrawer(); }
    toggle() { toggleDrawer(); }
  }

  customElements.define('cart-drawer', CartDrawer);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartTrigger);
  } else {
    bindCartTrigger();
  }

  function openDrawerFromParam() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('open_cart') !== '1') return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    url.searchParams.delete('open_cart');
    if (typeof history.replaceState === 'function') {
      history.replaceState({}, '', url.pathname + url.search + (url.hash || ''));
    }
    drawer.open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openDrawerFromParam);
  } else {
    openDrawerFromParam();
  }
})();